import { GroupNotification as GroupNotificationType } from '../types'
import { BaseNotificationItem } from '../BaseNotificationItem'
import Styles from '../NotificationItem.module.scss'
import { ReactComponent as GroupIcon } from 'assets/icons/twoMembers16.svg'
import { getGroupPath } from 'utils/urlUtils'

interface Props {
  notification: GroupNotificationType
  onClose: () => void
}

export const GroupNotification = ({ notification, onClose }: Props) => {
  const path = getGroupPath({ workspaceId: notification.workspace_id, groupId: notification.subject.id })
  const title = `added you to the group ${notification.subject.name}`

  return (
    <BaseNotificationItem
      notification={notification}
      onClose={onClose}
      title={title}
      icon={<GroupIcon role="img" title="Group Icon" className={Styles.icon} />}
      path={path}
      aria-label="Group Notification"
    />
  )
}
